// Styles for CardArtBadge

import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledCardArtBadge = styled.div`
  .m-badge-overlay-merch {
   * Bottom corners remain square to seamlessly connect with the image
   */
  .badge-border-style {
    border-radius: ${toRem(4)} ${toRem(4)} 0 0; /* Rounded top corners only */
  }

  /* ============================================
   * Card Image Styles
   * ============================================ */

  /**
   * Full-width card image styling
   * Uses webkit-fill-available for cross-browser compatibility
   * Ensures card image spans the entire available container width
   */
  .img-full-width {
    width: -webkit-fill-available; /* Webkit-specific fill width */
  }
`;
